import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../components/Header';
import {
  Typography,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Button,
  Container,
  Toolbar,
} from '@mui/material';
import { HomeIcon, SettingsIcon } from '../components/MuiIcons';
import EmojiEventsIcon from '../components/EmojiEventsIcon';
import ListItemButton from '@mui/material/ListItemButton';

const drawerWidth = 220;

const HomePage: React.FC = () => {
  const history = useHistory();
  const [drawerOpen, setDrawerOpen] = useState(false);

  let user = null;
  const stored = localStorage.getItem('user');
  if (stored && stored !== 'undefined' && stored !== null && stored.trim() !== '') {
    try {
      user = JSON.parse(stored);
      if (typeof user !== 'object' || user === null) {
        user = null;
        localStorage.removeItem('user');
      }
    } catch (e) {
      user = null;
      localStorage.removeItem('user');
    }
  }

  const handleMenuItemClick = (path: string) => {
    history.push(path);
    setDrawerOpen(false);
  };

  if (!user) {
    return (
      <Container maxWidth="md">
        <Box sx={{ mt: 8, textAlign: 'center' }}>
          <Typography variant="h3" gutterBottom>
            Welcome to Wine War
          </Typography>
          <Typography variant="h5" color="text.secondary" paragraph>
            Create and manage your food and wine battles
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() => history.push('/signin')}
            sx={{ mt: 4 }}
          >
            Get Started
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Header onMenuClick={() => setDrawerOpen(true)} title="Wine War" />

      <Drawer
        variant="temporary"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
      >
        <Toolbar />
        <Divider />
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleMenuItemClick('/home')}>
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary="Home" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleMenuItemClick('/competitions')}>
              <ListItemIcon>
                <EmojiEventsIcon />
              </ListItemIcon>
              <ListItemText primary="Battles" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleMenuItemClick('/settings')}>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Settings" />
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 4, mt: 8 }}>
        <Typography variant="h3" gutterBottom>
          Welcome back, {user.name}!
        </Typography>
            <Typography variant="h6" color="text.secondary" paragraph>
          Ready to create or join a battle?
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => history.push('/competitions')}
        >
          View Battles
        </Button>
      </Box>
    </Box>
  );
};

export default HomePage;